var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.931c0 .372-.104.736-.301 1.051l-2.022 3.235A1.166 1.166 0 0 0 2.666 15h14.668a1.166 1.166 0 0 0 .989-1.783L16.3 9.982a2 2 0 0 1-.3-1.05V7A6 6 0 0 0 4 7zM10 19a3 3 0 0 1-2.958-2.5h5.917A3 3 0 0 1 10 19"
  })));
};
export default SvgBell;